import api from "./api";

export const getBackendVersion = async () => {
    return await api.get("/version");
};